// Copyright ID Business Solutions Ltd. 2024
import styled from 'styled-components';

export const CheckboxContainer = styled.div`
  & idbs-checkbox {
    padding-right: 1rem;
  }
`;
